/* eslint-disable jsx-a11y/alt-text */
import { useContext, useEffect, useState } from "react";
import "../Assets/css/influencer.css";
import { useNavigate } from "react-router-dom";
import axiosMain from "../http/axiosMain";

import CampaignDetails from "../Assets/Img/Form.png";
import Audience from "../Assets/Img/People.png";
import Deliverables from "../Assets/Img/Social Media.png";
import Overview from "../Assets/Img/solar_checklist-outline.png";
import Compensationimg from "../Assets/Img/Compensationimg.png";
import TargetAudienceimg from "../Assets/Img/TargetAudienceimg.png";
import ExpectedDeliverablesimg from "../Assets/Img/ExpectedDeliverablesimg.png";
import fileicon from "../Assets/Img/fileicon.png";
import loadingGIF from "../Assets/Img/loadingGIF.gif";
import Search from "../Assets/Img/search.png";
import Heart from "../Assets/Img/Heart.png";
import HeartDark from "../Assets/Img/HeartDark.png";
import Filter from "../Assets/Img/Filter.png";
import create from "../Assets/Img/create dashboard.png";
import NoCamp from "../Assets/Img/amico.svg";
import DummyImg from "../Assets/Img/Rectangle 21.png";
import CalenderImg from "../Assets/Img/Calender.png";
import LocationImg from "../Assets/Img/Location.png";
import { Modal, Form, Dropdown } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { FaRegBookmark } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import LinkedIn from "../Assets/Img/LinkedIn.png";
import instagram from "../Assets/Img/Instagram.svg";
import youtube from "../Assets/Img/YouTube.svg";
import facebook from "../Assets/Img/facebook.png";
import CollaborateRequest from "../Assets/Img/Collaborate.pngRequest.png";
import { GlobalContext } from "../../utils/GlobalContext";

function InfluencerHome() {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [step1, setStep1] = useState(true);
  const [otp, setOtp] = useState(true); // Assume OTP is true initially
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const [showEditOptions, setShowEditOptions] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const states = ["California", "New York", "Texas", "Florida", "Illinois"];
  const [selectedCity, setSelectedCity] = useState("");
   const { userData, setUserData } = useContext(GlobalContext);
    const [isrefreshModalOpen, setIsModalOpen] = useState(
      !(localStorage.getItem("brand_name") && localStorage.getItem("brand_name").trim())
    );
    // const [isrefreshModalOpen, setIsModalOpen] = useState(!localStorage.getItem("brand_name"));

    
  const [selectedStates, setSelectedStates] = useState([]);
  const cities = [
    "Los Angeles",
    "New York City",
    "Houston",
    "Miami",
    "Chicago",
  ];
  const [profileDetails, setProfileDetails] = useState({
    brand_name: "",
    categories: [],
    bio: "",
    brand_website: "",
    social_links: "",
    state: "",
    pincode: "",
    user_photo: "",
    city: "",
    address: "",
    phone_no: "",
    email: "",
  });
  const [profileSetupDetails, setProfileSetupDetails] = useState({
    // brand_website: "",
    socialLinks: [{ platform: "Instagram", url: "" }],
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [selectedFilteName, setSelectedFilteName] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const statesWithCities = {
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara"],
    Karnataka: ["Bangalore", "Mysore", "Hubli"],
  };
  const [contentTypes, setContentTypes] = useState([
    {
      platform: "Instagram",
      items: [
        { id: "reels", label: "Reels", count: 1, checked: false },
        { id: "posts", label: "Posts", count: 1, checked: false },
        { id: "story", label: "Story", count: 1, checked: false },
      ],
    },
    {
      platform: "YouTube",
      items: [
        { id: "shorts", label: "Shorts", count: 1, checked: false },
        { id: "video", label: "Video", count: 1, checked: false },
        { id: "liveStream", label: "Live Stream", count: 1, checked: false },
      ],
    },
  ]);

  const handleIncrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    newContentTypes[platformIndex].items[itemIndex].count += 1;
    setContentTypes(newContentTypes);
  };

  const handleDecrement = (platformIndex, itemIndex) => {
    const newContentTypes = [...contentTypes];
    const currentCount = newContentTypes[platformIndex].items[itemIndex].count;
    if (currentCount > 0) {
      newContentTypes[platformIndex].items[itemIndex].count -= 1;
      setContentTypes(newContentTypes);
    }
  };
  const handleCheckboxChange = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosMain.get("/api/v1/get-categories");
        if (response.data && response.data.categories) {
          setCategories(response.data.categories); // Store API response
        } else {
          console.error("Invalid category format received:", response.data);
          setCategories([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]); // Fallback to empty array
      }
    };

    fetchCategories();
  }, []);
  const handlePrevbtn = () => {
    if (currentStep > 1) {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setEndDate(""); // Reset end date when start date changes
    setShowContent(false);
  };
  const formatSingleDate = (dateString) => {
    if (!dateString) return ""; // Handle empty or invalid dates
    const date = new Date(dateString);

    // Ensure valid date
    if (isNaN(date.getTime())) return "";

    const day = date.getUTCDate(); // Use UTC to avoid timezone shifts
    const month = date.toLocaleString("default", { month: "short" }); // Example: Feb
    const suffix = getDaySuffix(day); // Get suffix like st, nd, rd, th

    return `${day}${suffix} ${month}`;
  };

  const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return "th"; // Special case for 11, 12, 13
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setLoading(true);
    setShowContent(false);

    setTimeout(() => {
      setLoading(false);
      setShowContent(true);
    }, 2000); // Show loader for 2 seconds
  };

  const currentDate = new Date().toISOString().split("T")[0];

  const totalSteps = 4;

  const handleNext = () => {
    setStep1(!step1);
  };

  const handlePrev = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };
  const [selectedAge, setSelectedAge] = useState(null);

  const ageGroups = [
    "13-17",
    "18-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65+",
  ];

  const handleAgeSelect = (age) => {
    setSelectedAge(age);
  };

  const handleSaveDraft = () => {
    // Log save draft response here
    console.log("Draft Saved:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };

  const handlePublish = () => {
    // Log publish response here
    console.log("Campaign Published:", {
      startDate,
      endDate,
      contentTypes,
      selectedAge,
    });
  };
  const ViewDetails = (id) => {
    navigate(`/influancer-details/${id}`);
  };

  const navigate = useNavigate();

  useEffect(()=>{
    const role = localStorage.getItem("userType");
      if(role === "brand"){
        navigate('/brand-home')
      }else if(role!=="influencer"){
        navigate('/login')

      }
     
    },[])

  const createNavigate = () => {
    navigate("/campaign-create");
  };

  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const fetchData = async () => {
    try {
      const response = await axiosMain.get("/api/v1/all");
      console.log("Response Data:", response.data);
      setData(response.data.campaigns);
      setOriginalInfluencers(response.data.campaigns);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const [activeTab, setActiveTab] = useState("recent");

  const isautopublished = data?.filter((ele) => ele);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    if (query?.length > 0) {
      const filtered = data.filter((campaign) =>
        campaign.campaign_title?.toLowerCase().includes(query.toLowerCase())
      );
      setData(filtered);
    } else {
      fetchData();
    }
  };

  const isModalOpen = localStorage.getItem("openModal") === "true";
  const [isSavedFiltered, setIsSavedFiltered] = useState(false);
  const [originalInfluencers, setOriginalInfluencers] = useState([]);
  const [bookmark, setBookmark] = useState(new Set());

  const handleCloseEditProfileModal = () => {
    setShowEditProfileModal(false);
  };

  useEffect(() => {
    if (otp) {
      setShowEditProfileModal(true);
    }
  }, [otp]);

  const handleSaveBookmark = () => {
    if (isSavedFiltered) {
      // 🔹 Restore all data correctly
      setData([...originalInfluencers]);
    } else {
      const savedInfluencers = originalInfluencers.filter((influencer) =>
        bookmark.has(influencer.campaign_id)
      );

      setData(savedInfluencers);
    }
    setIsSavedFiltered(!isSavedFiltered);
  };
  const handleFileSelect = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
   
      reader.onload = async (event) => {
        const arrayBuffer = event.target.result;
        const buffer = new Uint8Array(arrayBuffer); // Convert to Uint8Array
   
        const fileData = {
          fieldname: "logo",
          originalname: selectedFile.name,
          encoding: "7bit",
          mimetype: selectedFile.type,
          buffer: buffer,
          size: selectedFile.size,
        };
   
        // Generate a Data URL for preview
        const previewReader = new FileReader();
        previewReader.onload = (e) => {
          // Update profileDetails
          setProfileDetails((prev) => ({
            ...prev,
            logo: fileData,
            logoPreview: e.target.result,
          }));
   
          // Update userData for Navbar using GlobalContext
          setUserData((prev) => ({
            ...prev,
            user_photo: e.target.result, // Assuming user_photo is for navbar display
          }));
        };
   
        previewReader.readAsDataURL(selectedFile);
      };
   
      reader.readAsArrayBuffer(selectedFile); // Read as ArrayBuffer
    }
  };

  // const handleFileSelect = async (e) => {
  //   // debugger;
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const reader = new FileReader();

  //     reader.onload = async (event) => {
  //       const arrayBuffer = event.target.result;

  //       const buffer = new Uint8Array(arrayBuffer); // Convert ArrayBuffer to Uint8Array

  //       // Create an object similar to what the backend expects
  //       const fileData = {
  //         fieldname: "logo",
  //         originalname: selectedFile.name,
  //         encoding: "7bit",
  //         mimetype: selectedFile.type,
  //         buffer: buffer, // This is a Uint8Array, similar to a Buffer in Node.js
  //         size: selectedFile.size,
  //       };

  //       // setFile(fileData);
  //       // setSelectedFilteName(selectedFile.name);
  //       setProfileDetails({ ...profileDetails, logo: fileData });
  //     };

  //     reader.readAsArrayBuffer(selectedFile); // Read file as ArrayBuffer (binary data)
  //   }
  // };

  const handleSave = async () => {
    const requestBody = {
      brand_name: profileDetails.name || "",
      categories: selectedCategories.join(", ") || "",
      bio: profileSetupDetails.bio || "",
      brand_website: profileSetupDetails.website || "",
      // social_links: JSON.stringify(profileSetupDetails.socialLinks) || "",
      // flat_apartment: profileDetails.address || "",
      city: selectedCity || "",
      address: profileDetails.address || "",
      state: selectedStates[0] || "",
      pincode: profileDetails.pin || "",
      file: profileDetails.logo || "",
      phone_no: `91${profileDetails.phone || ""}`,
      email: profileDetails.email || "",
    };

    // Create a FormData object
    const formData = new FormData();

    // Append non-file fields
    await Object.keys(requestBody).forEach((key) => {
      if (key === "file") {
        // debugger;
        const fileData = requestBody.file;

        if (fileData?.buffer) {
          const blob = new Blob([fileData.buffer], { type: fileData.mimetype });
          formData.append("file", blob, fileData.originalname);
        } else if (fileData instanceof File) {
          formData.append("file", fileData);
        }
      }
      if (key === "brand_name") {
        formData.append("brand_name", requestBody.brand_name);
      }
      if (key === "categories") {
        formData.append("categories", requestBody.categories);
      }
      if (key === "bio") {
        formData.append("bio", requestBody.bio);
      }
      if (key === "brand_website") {
        formData.append("brand_website", requestBody.brand_website);
      }
      if (key === "city") {
        formData.append("city", requestBody.city);
      }
      if (key === "address") {
        formData.append("address", requestBody.address);
      }
      if (key === "state") {
        formData.append("state", requestBody.state);
      }
      if (key === "pincode") {
        formData.append("pincode", requestBody.pincode);
      }
      if (key === "email") {
        formData.append("email", requestBody.email);
      }
      if (key === "phone_no") {
        formData.append("phone_no", requestBody.phone_no);
      }
      // if (key === "brand_name") {
      //   formData.append("brand_name", profileDetails.brand_name);
      // }
      //  else {
      //   formData.append(key, requestBody[key] || " ");
      // }
    });

    try {
      const response = await axiosMain.post("/api/v1/brand-profile", formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensure correct content type
        },
      });

      console.log("API Response:", response.data);
      localStorage.setItem("brand_name", requestBody.brand_name); // Store brand name
      setIsModalOpen(false); // Close modal
    
      handleCloseEditProfileModal();
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  return (
    <>
      {/* Influencer-Home Page Content */}
      {isModalOpen && isrefreshModalOpen && (
        <Modal
          className="ModalBox"
          show={showEditProfileModal}
          onHide={handleCloseEditProfileModal}
          size="sm" // Small modal
          backdrop="static" // Prevent closing when clicking outside
          keyboard={false} // Prevent closing with Escape key
        >
          <Modal.Body>
            {/* Close Button */}
            <button
              type="button"
              className="btn-close"
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                background: "none",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
              onClick={handleCloseEditProfileModal}
            >
              ✖
            </button>
            <div className="TitleTag">Let’s setup your Profile!</div>

            <Form>
              {step1 ? (
                <>
                  <div
                    style={{
                      maxHeight: "500px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#888 #f1f1f1",
                    }}
                  >
                    {/* Logo Upload Section */}
                    <Form.Group controlId="formLogo" className="text-center">
                      <div className="d-flex flex-column align-items-center position-relative">
                        {/* Hidden File Input */}
                        <input
                          type="file"
                          accept="image/*"
                          id="fileInput"
                          onChange={handleFileSelect}
                          className="d-none drop "
                        />

                        {/* Clickable Image/Placeholder with Position Relative */}
                        <div
                          className="position-relative"
                          style={{ width: "110px", height: "110px" }}
                        >
                          <div
                            className="rounded-circle d-flex align-items-center justify-content-center w-100 h-100"
                            style={{
                              backgroundColor: profileDetails.logo
                                ? "transparent"
                                : "#f0f0f0",
                              cursor: "pointer",
                              overflow: "hidden",
                            }}
                            onClick={() =>
                              document.getElementById("fileInput").click()
                            } // Click on file input
                          >
                            {profileDetails.logo ? (
                              <img
                                src={profileDetails.logo}
                                alt="Logo Preview"
                                className="rounded-circle w-100 h-100"
                                style={{ objectFit: "cover" }}
                              />
                            ) : (
                              <span>No Image</span>
                            )}
                          </div>

                          {/* Edit Button (Positioned at Bottom-Right of Image) */}
                          {profileDetails.logo && (
                            <div
                              className="position-absolute"
                              style={{ bottom: "-5px", right: "-5px" }}
                            >
                              <Dropdown
                                show={showEditOptions}
                                onToggle={(isOpen) =>
                                  setShowEditOptions(isOpen)
                                }
                              >
                                {/* Edit Icon as Custom Trigger */}
                                <div
                                  onClick={() =>
                                    setShowEditOptions(!showEditOptions)
                                  }
                                  style={{
                                    backgroundColor: "#6B8E76",
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                    border: "2px solid white",
                                  }}
                                >
                                  <FaEdit color="white" size={16} />
                                </div>

                                {/* Dropdown Menu */}
                                <Dropdown.Menu align="end">
                                  <Dropdown.Item
                                    onClick={() => {
                                      document
                                        .getElementById("fileInput")
                                        .click();
                                      setShowEditOptions(false);
                                    }}
                                  >
                                    Edit Profile Picture
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => {
                                      setProfileDetails((prevState) => ({
                                        ...prevState,
                                        logo: null,
                                      }));
                                      setShowEditOptions(false);
                                    }}
                                  >
                                    Remove Profile Picture
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          )}
                        </div>
                      </div>
                    </Form.Group>

                    {/* Two-Column Layout */}

                    <div className="row">
                      {/* Brand Name */}
                      <div className="col-md-6">
                        <Form.Group controlId="formName">
                          <Form.Label>Your Name</Form.Label>
                          <Form.Control
                            type="text"
                            value={profileDetails.name}
                            onChange={(e) =>
                              setProfileDetails({
                                ...profileDetails,
                                name: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>

                      {/* Phone Number */}
                      <div className="col-md-6">
                        <Form.Group controlId="formPhone">
                          <Form.Label>Phone Number</Form.Label>
                          <Form.Control
                            type="text"
                            value={profileDetails.phone}
                            onChange={(e) =>
                              setProfileDetails({
                                ...profileDetails,
                                phone: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>

                      {/* Email ID */}
                      <div className="col-md-6">
                        <Form.Group controlId="formEmail">
                          <Form.Label>Email ID</Form.Label>
                          <Form.Control
                            type="email"
                            value={profileDetails.email}
                            onChange={(e) =>
                              setProfileDetails({
                                ...profileDetails,
                                email: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>

                      {/* Brand Category Dropdown */}
                      <div className="col-md-6">
                        <Form.Group controlId="formCategory">
                          <Form.Label>Select Your Brand's Category</Form.Label>
                          <Dropdown
                            show={openDropdown === "category"}
                            onToggle={(isOpen) =>
                              setOpenDropdown(isOpen ? "category" : null)
                            }
                            className="w-100"
                          >
                            <Dropdown.Toggle
                              variant="light"
                              className="w-100 drop text-start"
                            >
                              {selectedCategories.length > 0
                                ? selectedCategories.join(", ")
                                : "Select Categories"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100 p-2">
                              {categories.map((category, index) => (
                                <div key={index} className="dropdown-item">
                                  <Form.Check
                                    type="checkbox"
                                    label={category}
                                    checked={selectedCategories.includes(
                                      category
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(category, "category")
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </div>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Form.Group>
                      </div>

                      {/* State Dropdown */}
                      <div className="col-md-6">
                        <Form.Group controlId="formState">
                          <Form.Label>State</Form.Label>
                          <Dropdown
                            show={openDropdown === "state"}
                            onToggle={(isOpen) =>
                              setOpenDropdown(isOpen ? "state" : null)
                            }
                            className="w-100"
                          >
                            <Dropdown.Toggle
                              variant="light"
                              className="w-100 drop text-start"
                            >
                              {selectedStates.length > 0
                                ? selectedStates[0]
                                : "Select State"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100 p-2">
                              {states.map((state, index) => (
                                <Dropdown.Item
                                  key={index}
                                  onClick={() => setSelectedStates([state])} // Allow only one state selection
                                >
                                  {state}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Form.Group>
                      </div>

                      {/* City Dropdown */}
                      <div className="col-md-6">
                        <Form.Group controlId="formCity">
                          <Form.Label>City</Form.Label>
                          <Dropdown
                            show={openDropdown === "city"}
                            onToggle={(isOpen) =>
                              setOpenDropdown(isOpen ? "city" : null)
                            }
                            className="w-100"
                          >
                            <Dropdown.Toggle
                              variant="light"
                              className="w-100 drop text-start"
                            >
                              {selectedCity || "Select City"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100 p-2">
                              {cities.map((city, index) => (
                                <Dropdown.Item
                                  key={index}
                                  onClick={() => setSelectedCity(city)}
                                >
                                  {city}
                                </Dropdown.Item>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Form.Group>
                      </div>

                      {/* Address */}
                      <div className="col-md-6">
                        <Form.Group controlId="formAddress">
                          <Form.Label>Address</Form.Label>
                          <Form.Control
                            type="text"
                            value={profileDetails.address}
                            onChange={(e) =>
                              setProfileDetails({
                                ...profileDetails,
                                address: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>

                      {/* PIN Code */}
                      <div className="col-md-6">
                        <Form.Group controlId="formPin">
                          <Form.Label>PIN Code</Form.Label>
                          <Form.Control
                            type="text"
                            value={profileDetails.pin}
                            onChange={(e) =>
                              setProfileDetails({
                                ...profileDetails,
                                pin: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                    {/* Brand Bio (Full Width) */}
                    <div className="col-md-12 mt-3">
                      <Form.Group controlId="formBio">
                        <Form.Label>A Brief Bio</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={profileSetupDetails.bio}
                          onChange={(e) =>
                            setProfileSetupDetails({
                              ...profileSetupDetails,
                              bio: e.target.value,
                            })
                          }
                          placeholder="Tell us about your brand..."
                        />
                      </Form.Group>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Form.Group controlId="formWebsite">
                    <Form.Label>Your Website (Optional)</Form.Label>
                    <Form.Control
                      type="text"
                      value={profileSetupDetails.website}
                      // onChange={(e) => handleInputChange(e, "website")}
                    />
                  </Form.Group>

                  <h5>Your Social Media Links</h5>
                  {profileSetupDetails.socialLinks.map((link, index) => (
                    <Form.Group
                      key={index}
                      controlId={`formSocialLink${index}`}
                      className="position-relative"
                    >
                      <Form.Label>{link.platform}</Form.Label>
                      <div className="row align-items-center">
                        {/* Instagram Field */}
                        <div className="col-md-4">
                          <Form.Group controlId="formInstagram">
                            <div className="input-container">
                              <img
                                src={instagram}
                                alt="Instagram"
                                className="social-icon"
                              />
                              <Form.Control
                                type="text"
                                placeholder=""
                                className="social-input"
                              />
                            </div>
                          </Form.Group>
                        </div>

                        {/* YouTube Field */}
                        <div className="col-md-4">
                          <Form.Group controlId="formInstagram">
                            <div className="input-container">
                              <img
                                src={youtube}
                                alt="Instagram"
                                className="social-icon"
                              />
                              <Form.Control
                                type="text"
                                placeholder=""
                                className="social-input"
                              />
                            </div>
                          </Form.Group>
                        </div>

                        {/* Facebook Field */}
                        <div className="col-md-4">
                          <Form.Group controlId="formFacebook">
                            <div className="d-flex align-items-center border rounded p-2 bg-white">
                              <img
                                src={facebook}
                                alt="Facebook"
                                className="me-2"
                                width="24"
                                height="24"
                              />
                              <Form.Control
                                type="text"
                                placeholder="Facebook"
                                className="border-0 shadow-none"
                              />
                            </div>
                          </Form.Group>
                        </div>

                        {/* LinkedIn Field */}
                        <div className="col-md-4 mt-3">
                          <Form.Group controlId="formLinkedIn">
                            <div className="d-flex align-items-center border rounded p-2 bg-white">
                              <img
                                src={LinkedIn}
                                alt="LinkedIn"
                                className="me-2"
                                width="24"
                                height="24"
                              />
                              <Form.Control
                                type="text"
                                placeholder="LinkedIn"
                                className="border-0 shadow-none"
                              />
                            </div>
                          </Form.Group>
                        </div>
                        <div className="d-flex flex-column align-items-center col-md-2 mt-3">
                          <button
                            type="button"
                            className="border-0 bg-transparent"
                          >
                            <FaPlus
                              style={{
                                color: "#6B8E76",
                                height: "24px",
                                width: "22px",
                              }}
                            />
                          </button>
                          <span
                            style={{ color: "#00000085", fontSize: "14px" }}
                          >
                            Add More Links
                          </span>
                        </div>
                      </div>
                    </Form.Group>
                  ))}
                </>
              )}

              <div className="d-flex justify-content-between mt-4 mb-3">
                <button
                  type="button"
                  className="btn profile-clear-btn"
                  // onClick={() => resetAllFilters()}
                >
                  Clear All
                </button>
                <div>
                  <button
                    type="button"
                    className="profile btn btn-outline-success mx-2"
                    onClick={handleSave}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className=" profile btn btn-success"
                    onClick={handleNext}
                  >
                    {step1 ? "Next" : "Previous"}
                  </button>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      )}

      <div className="campaignCreate">
        <div>
          <div className="SearchFilterSection">
            <div className=" d-flex justify-content-end align-items-center w-100">
              <div className="d-flex justify-content-end">
                <div className="SearchInput">
                  <img src={Search} className="img-fluid" alt="Search Icon" />
                  <input
                    type="text"
                    className="form-control m-0"
                    placeholder="Search for"
                    value={searchQuery}
                    onChange={handleSearch} // Call function on input change
                  />
                </div>
                <button>
                  Filter{" "}
                  <img src={Filter} className="img-fluid" alt="Filter Icon" />
                </button>
                <button onClick={handleSaveBookmark}>
                  Save <FaRegBookmark />
                </button>
              </div>
            </div>
          </div>

          {/* Show "No Campaigns" message if data is empty */}
          {data.length === 0 ? (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
              <div className="text-center px-4 max-w-md mx-auto">
                <div>
                  <img
                    src={NoCamp}
                    alt="No Campaigns"
                    className="object-contain"
                  />
                </div>
                <h2 className="Title">Welcome to the Campaign!</h2>
                <p className="text-gray-600 mb-8">
                  Currently, there are no saved campaigns available.
                </p>
              </div>
            </div>
          ) : (
            <div>
              <h3>Saved Campaigns</h3>
              {data.map((campaign) => (
                <div key={campaign.id}>{campaign.name}</div>
              ))}
            </div>
          )}
        </div>
        <div className="CreatedCampaigns mt-4">
          <div className="tab-content">
            <div className="row g-4">
              {isautopublished?.map((ele) => (
                <div
                  key={ele.campaign_id}
                  className="col-xl-3 col-lg-4 col-md-6"
                >
                  <div className="campaign-card">
                    <img
                      src={ele.campaign_poster || DummyImg}
                      alt={ele.campaign_title}
                      className="campaign-image w-100"
                    />
                    <div className="p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="StatusCamp">
                          <h5 className="mb-1">{ele.campaign_title}</h5>
                          <span className="status-badge">
                            <span className="OngoingShap"></span> Ongoing
                          </span>
                        </div>
                      </div>
                      <p className="mb-2">{ele.campaign_obj}</p>
                      <div className="d-flex align-items-center mb-2">
                        <span className="date-text">
                          <img
                            src={CalenderImg}
                            className="img-fluid"
                            alt="calendar"
                          />
                          {formatSingleDate(ele.start_date)} to{" "}
                          {formatSingleDate(ele.end_date)}
                        </span>
                      </div>
                      <span className="location-text">
                        <img
                          src={LocationImg}
                          className="img-fluid"
                          alt="location"
                        />
                        {ele.city}, {ele.state}
                      </span>
                      <hr />
                      <div className="mb-3">
                        <p className="mb-2">Deliverables</p>
                        <div>
                          <span className="language-tag">Bn</span>
                          <span className="language-tag">Eng</span>
                          <span className="language-tag">gujj</span>
                          <span className="language-tag">Eng</span>
                        </div>
                      </div>
                    </div>
                    <div className="CardBtn">
                      <button onClick={() => ViewDetails(ele.campaign_id)}>
                        View Details
                      </button>

                      <button
                        className="CollaborateRequest"
                        onClick={() => ViewDetails(ele.campaign_id)}
                      >
                        Collaborate{" "}
                        <img src={CollaborateRequest} className="img-fluid" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InfluencerHome;
